import React, { useEffect, useState } from "react"
import { Alert, Col, Container, Row } from "reactstrap"
import { Link } from "react-router-dom"
import { get } from "api/axios"
import endpoints from "api/endpoints"
import VideoCard from "components/Common/Cards/VideoCard"

export default function VideosByDockies() {
  const tabsMenu = [
    "all",
    "dads jokes",
    "new and trending",
    "best seller",
    "independence",
    "heartthrobs",
  ]

  const [videoData, setVideoData] = useState([])
  const [loadMore, setLoadMore] = useState({
    currentPage: 1,
    lastPage: 1,
  })
  const [loading, setLoading] = useState(true)

  const [isWideScreen, setIsWideScreen] = useState(window.innerWidth > 1780)

  const getFetch = async (nextPage = 1) => {
    setLoading(true)
    try {
      const resp = await get(
        `${endpoints.getVideos}?page=${nextPage}&filter=activeTopic&limit=${
          isWideScreen ? 8 : 5
        }&status=active`
      )

      if (resp?.data?.success) {
        setVideoData(prev => [...prev, ...resp?.data?.data])
        setLoadMore({
          currentPage: resp?.data?.currentPage,
          lastPage: resp?.data?.totalPages,
        })
      }
    } catch (error) {
      console.error("Fetch error:", error)
    }
    setLoading(false)
  }

  const handleLoadMore = () => {
    const nextPage = loadMore.currentPage + 1
    getFetch(nextPage)
  }

  useEffect(() => {
    setIsWideScreen()
    setVideoData([])
    setLoadMore({ currentPage: 1, lastPage: 1 })
    getFetch(1)
  }, [])

  return (
    <div className="card rounded-4 p-4 shadow">
      <Row className=" justify-content-center">
        <Col xs="12">
          <Row>
            <div className="d-flex flex-column flex-md-row justify-content-between align-items-center ">
              <div className="d-flex gap-2 flex-column flex-md-row align-items-center">
                <div>
                  <span className="fw-medium font-size-18 text-darkcolor">
                    VIDEOS POSTED BY DOCKIES
                  </span>
                </div>
                <div>
                  <select
                    className="custom-select rounded-pill gray-700 font-size-14 bg-skin p-2 mb-2 mb-md-0"
                    id="customSelect"
                    style={{ border: "none" }}
                  >
                    <option defaultValue>Filter By Categories</option>
                    <option value="1">Last Month</option>
                    <option value="2">Last Three Month</option>
                    <option value="3">Last Year</option>
                    <option value="4">Older</option>
                  </select>
                </div>
              </div>
              <div>
                {videoData.length > 0 && (
                  <Link
                    to={"/videovaults"}
                    className="text-uppercase pre-text fw-medium font-size-14 ff-barlow"
                  >
                    view all
                  </Link>
                )}
              </div>
            </div>
          </Row>
          <Row className="mt-4 row-gap-3 ">
            {loading ? (
              <Col>
                <div className="text-center py-5">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              </Col>
            ) : videoData?.length > 0 ? (
              videoData.map(card => (
                <Col
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  className="col-xxl-5th"
                  key={card.id}
                >
                  <VideoCard data={card} imageHeight={364} />
                </Col>
              ))
            ) : (
              <Col>
                <Alert className="text-center">No Content Found!</Alert>
              </Col>
            )}
          </Row>

          {loadMore.lastPage !== loadMore.currentPage && (
            <Row className="justify-content-center mt-3 mb-2">
              <div className="text-center">
                <button
                  className="btn btn-primary-green text-uppercase"
                  onClick={handleLoadMore}
                >
                  Come on, show us what you’ve got!{" "}
                </button>
              </div>
            </Row>
          )}
        </Col>
      </Row>
    </div>
  )
}
